import { createTheme } from '@material-ui/core'
const mainColor = process.env.REACT_APP_MAIN_COLOR
const secColor = process.env.REACT_APP_SECONDARY_COLOR

const btnText = '#FFFFFF'

const theme = createTheme({
    palette: {
        primary: {
            main: mainColor,
        },
    },
    overrides: {
        MuiAppBar: {
            root: {
                backgroundColor: mainColor,
            },
        },
        MuiButton: {
            root: {
                backgroundColor: secColor,
                color: btnText,
                fontFamily: 'Roboto',
				fontSize: '16px',
				fontWeight: 600,
                boxShadow: 'none',
                textTransform: 'none',
				'&:hover': {
					backgroundColor: secColor,
                    fontSize: '16px',
                    boxShadow: 'none',
				},
				'&:active': {
					backgroundColor: secColor,
				},
				'&:focus': {
					backgroundColor: secColor,
				},
            },
        },
        MuiTextField: {
            root: {
                fontFamily: "Montserrat",
            },
        },
        MuiTypography: {
            root: {
                fontFamily: "Montserrat",
            },
        }
    },
});

export default theme